/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Club_No_RoundInputs */

const en_us2_club_no_round = /** @type {(inputs: Club_No_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This club has no round running.`)
};

const pt_br2_club_no_round = /** @type {(inputs: Club_No_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este clube não tem rodada em andamento.`)
};

const es_419_club_no_round = /** @type {(inputs: Club_No_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este club no tiene ninguna ronda en curso.`)
};

const pt_pt2_club_no_round = /** @type {(inputs: Club_No_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este clube não tem nenhuma ronda a decorrer.`)
};

const fr_fr2_club_no_round = /** @type {(inputs: Club_No_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce club n'a aucune manche en cours.`)
};

const de_de2_club_no_round = /** @type {(inputs: Club_No_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In diesem Club läuft keine Runde.`)
};

const it_it2_club_no_round = /** @type {(inputs: Club_No_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo club non ha un turno in corso.`)
};

/**
* | output |
* | --- |
* | "This club has no round running." |
*
* @param {Club_No_RoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const club_no_round = /** @type {((inputs?: Club_No_RoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Club_No_RoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_club_no_round(inputs)
	if (locale === "es-419") return es_419_club_no_round(inputs)
	if (locale === "pt-PT") return pt_pt2_club_no_round(inputs)
	if (locale === "fr-FR") return fr_fr2_club_no_round(inputs)
	if (locale === "de-DE") return de_de2_club_no_round(inputs)
	if (locale === "it-IT") return it_it2_club_no_round(inputs)
	return en_us2_club_no_round(inputs)
});
export { club_no_round as "club.no_round" }